import { render, staticRenderFns } from "./ColloquiaPage.vue?vue&type=template&id=3e615295&scoped=true"
import script from "./ColloquiaPage.vue?vue&type=script&lang=js"
export * from "./ColloquiaPage.vue?vue&type=script&lang=js"
import style0 from "./ColloquiaPage.vue?vue&type=style&index=0&id=3e615295&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e615295",
  null
  
)

export default component.exports